// components/TrustBadges/badges.tsx — badge list builder
import type { BadgeItem, TrustBadgesProps } from './types';
import { buildBadgesPart1 } from './badgesPart1';
import { buildBadgesPart2 } from './badgesPart2';

export const buildBadges = (settings: TrustBadgesProps['settings']): BadgeItem[] => [
    ...buildBadgesPart1(settings.badges),
    ...buildBadgesPart2(settings.badges),
];
